import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedNotificationsPreferencesPage.meta';

export const useTrackViewedNotificationsPreferencesPage = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedNotificationsPreferencesPage = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackViewedNotificationsPreferencesPage };
};
